import {} from './configs/_global.config';

import {
    jaJP,
    thTH,
    globalResources,
    defaultResources,
    viVN,
    koKR,
    zhHant,
    zhHans,
} from './configs';
import { ICultureResources } from '../models';

export { globalResources, defaultResources as defaultCulture };

export const cultureResources: Record<string, ICultureResources> = {
    'ja-JP': jaJP,
    'ko-KR': koKR,
    'th-TH': thTH,
    'vi-VN': viVN,
    'zh-Hans': zhHans,
    'zh-Hant': zhHant,
};
